module.exports = __webpack_public_path__ + "static/media/ExpireSoon.21e7f416.svg";